import { Component, EventEmitter, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { noGroup } from '@core/helpers';
import { UserGroupService } from '@core/services/user-group.service';
import { TranslateModule } from '@ngx-translate/core';
import { EllipsisTooltipComponent } from '@shared/components';
import { TooltipFocusHandlerDirective } from '@shared/directives/tooltip-focus-handler.directive';
import { AppRoutes } from '@shared/helpers';
import { UserGroup } from '@shared/interfaces';
import { orderBy } from 'lodash';
import { ButtonModule } from 'primeng/button';
import { FocusTrapModule } from 'primeng/focustrap';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'app-menu-group[closePopover]',
    templateUrl: './menu-group.component.html',
    styleUrls: ['./menu-group.component.scss'],
    standalone: true,
    imports: [
        ButtonModule,
        TranslateModule,
        RouterLink,
        EllipsisTooltipComponent,
        TooltipModule,
        FocusTrapModule,
        TooltipFocusHandlerDirective,
    ],
})
export class MenuGroupComponent {
    @Output() closePopover: EventEmitter<void> = new EventEmitter<void>();

    userGroups: UserGroup[] = [];
    isGroupsLoading: boolean = false;
    selectedGroupId = noGroup.id;

    readonly appRoutes = AppRoutes;

    constructor(private userGroupService: UserGroupService) {
        this.userGroupService.currentGroup$.subscribe(userGroup => {
            if (userGroup) {
                this.selectedGroupId = userGroup.id;
                this.sortGroups();
            }
        });

        this.userGroupService.groups$.subscribe(res => {
            if (res) {
                this.userGroups = res;
                this.sortGroups();
            }
        });
    }

    async selectGroup(group: UserGroup) {
        if (group.id === this.selectedGroupId) return;

        const event = await this.userGroupService.getSaveChangesModalResponse();
        if (event === 'cancel') return;

        this.isGroupsLoading = true;
        await this.userGroupService.switchGroup(group, { navigateTo: 'dashboard' });
        this.isGroupsLoading = false;
    }

    close(): void {
        this.closePopover.emit();
    }

    stopPropagation(event: any) {
        event.stopPropagation();
    }

    private sortGroups(): void {
        if (this.selectedGroupId === noGroup.id) {
            return;
        }

        const currentGroupId = this.selectedGroupId;
        const orderedGroups = orderBy(
            this.userGroups,
            [
                function (group) {
                    return group.id === currentGroupId;
                },
                function (group) {
                    return group.name?.trim().toLowerCase();
                },
            ],
            ['desc', 'asc']
        );

        this.userGroups = orderedGroups;
    }
}
